import { createSlice } from "@reduxjs/toolkit";

/**
 * Initial state for the auth slice.
 * @typedef {Object} AuthState
 * @property {string|null} token - JWT or session token.
 * @property {boolean} isAuthenticated - Whether the user is authenticated.
 */
const initialState = {
  token: null,
  isAuthenticated: false,
};

/**
 * Redux slice for handling authentication state.
 */

/**
 * Logs in the user by saving the token and setting isAuthenticated.
 * @param {AuthState} state
 * @param {Object} action
 * @param {string} action.payload - The authentication token.
 */

/**
 * Logs out the user by clearing the token and auth flag.
 * Also purges persisted state if needed.
 * @param {AuthState} state
 */

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

export const { login, logout } = authSlice.actions; // Export actions
export default authSlice.reducer; // Export reducer
